export function getAverageConfidence(fields: number[]): number {
  const sum = fields.reduce(
    (prev: number, confidence: number) => prev + confidence,
    0
  );

  return sum / (fields?.length || 0);
}
